export default "__VITE_ASSET__DTZzGvVv__"